import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth-context";
import { ReactComponent as AppLoaderSvg } from "../../assets/img/app-loader.svg";

const BLOCKED_RETURN_PATHS = [
  "/auth-callback",
  "/auth-callback-logout",
  "/auth-callback-silent",
  "/login",
  "/post-logout",
  "/forgotpassword",
];

const sanitizeReturnPath = (path) => {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) {
    return "/";
  }

  const pathname = path.split("?")[0];
  if (BLOCKED_RETURN_PATHS.includes(pathname)) {
    return "/";
  }

  return path;
};

function AuthCallback() {
  const { userManager, setIsLoading, applyAuthenticatedUser } = useAuth();
  
  const navigate = useNavigate();
  const handledRef = useRef(false);

  useEffect(() => {
    const handleSignIn = async () => {
      if (handledRef.current) return;
      handledRef.current = true;

      try {
        setIsLoading(true);
        const user = await userManager.signinRedirectCallback();
        const returnPath = sanitizeReturnPath(
          user?.state?.returnPath
        );

        if (applyAuthenticatedUser) {
          await applyAuthenticatedUser(user);
        }

        setIsLoading(false);
        navigate(returnPath, { replace: true });
      } catch (error) {
        setIsLoading(false);
        if (error && error.message === "invalid_grant") {
          navigate("/", { replace: true });
        } else {
          console.error("Error during sign-in callback:", error);
          navigate("/", { replace: true });
        }
      }
    };
    handleSignIn();
  }, [userManager, navigate, setIsLoading, applyAuthenticatedUser]);

  return (
    <div
      className="app-loading-screen primary"
      role="status"
      aria-live="polite"
    >
      <AppLoaderSvg
        className="app-loader-svg"
        width={200}
        height={200}
        focusable="false"
      />
      <span>Loading...</span>
    </div>
  );
}

export default AuthCallback;
